module.exports = __webpack_public_path__ + "images/components/new_arrival_estimate_entries/megaphone@2x_1616779aee165d5e6d067b0a14396364.png";